import $ from "jquery";

const showMore = $(".show-more ");

showMore.on("click", function () {
  let hiddentText = $(this).siblings(".text").find(".hidden-text");
  if (hiddentText.is(":visible")) {
    hiddentText.hide();
  } else {
    hiddentText.show();
  }
});

